import React from 'react';
import { motion } from 'framer-motion';
import { FaFacebook, FaInstagram, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <motion.div
          className="footer-section"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <div className="footer-logo">
            <h3>Yolla Food</h3>
          </div>
          <p>Votre restaurant préféré pour des plats délicieux livrés directement chez vous.</p>
          <div className="social-links">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon">
              <FaFacebook />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon">
              <FaInstagram />
            </a>
          </div>
        </motion.div>

        <motion.div
          className="footer-section"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <h3>Contact</h3>
          <p>
            <FaMapMarkerAlt style={{ marginRight: '10px' }} />
            81 Rue Bernard Palissy<br />
            45500 Gien
          </p>
          <p>
            <FaPhone style={{ marginRight: '10px' }} />
            02 18 49 30 80
          </p>
        </motion.div>

        <motion.div
          className="footer-section"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <h3>Horaires</h3>
          <p>Lundi - Vendredi: 11h00 - 22h00</p>
          <p>Samedi - Dimanche: 12h00 - 23h00</p>
        </motion.div>

        <motion.div
          className="footer-section"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <h3>Liens Utiles</h3>
          <a href="#cgv">Conditions Générales de Vente</a>
          <a href="#privacy">Politique de Confidentialité</a>
          <a href="#mentions">Mentions Légales</a>
        </motion.div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2025 Yolla Food. Tous droits réservés.</p>
      </div>
    </footer>
  );
};

export default Footer;
